import React, { useState } from 'react';
import { Phone, ChevronDown, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const services = ['Scar Camouflage', 'Facial Camouflage', 'Areola Restoration', 'Birth Marks Camouflage', 'Stretch Mark Microneedling', 'Stretch Mark Camouflage', 'Vitiligo Camouflage', 'Tattoo Laser Removal'];
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'Before & After',
    href: '#testimonials'
  }, {
    name: 'Training',
    href: '#what-we-do'
  }, {
    name: 'About Us',
    href: '#about'
  }, {
    name: 'Contact Us',
    href: '#footer'
  }, {
    name: 'Book Appointment',
    href: '#'
  }, {
    name: 'FAQs',
    href: '#'
  }];
  return <header className="fixed w-full top-0 z-50 flex flex-col" data-id="element-108">
      {/* Top Bar */}
      <div className="bg-black text-cream py-2 px-6 flex justify-end items-center text-xs tracking-widest uppercase font-sans" data-id="element-109">
        <a href="tel:+17269007476" className="flex items-center gap-2 hover:text-taupe transition-colors duration-300" data-id="element-110">
          <Phone size={12} data-id="element-111" />
          <span data-id="element-112">Call or Text START to +1 726-900-7476</span>
        </a>
      </div>

      {/* Main Nav */}
      <div className="bg-cream/95 backdrop-blur-md border-b border-taupe/20 px-6 lg:px-12 py-4 flex justify-between items-center transition-all duration-300" data-id="element-113">
        <a href="#" className="flex-shrink-0" data-id="element-114">
          <img src="https://cdn.magicpatterns.com/uploads/6FZjPCLYqUBn4ERm3EJSWZ/1DP-PELogo350x180.png" alt="Parkway Esthetics" className="h-12 lg:h-16 object-contain" data-id="element-115" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-116">
          <a href="#" className="text-sm uppercase tracking-widest font-sans hover:text-taupe-dark transition-colors relative group" data-id="element-117">
            Home
            <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-taupe-dark transition-all duration-300 group-hover:w-full" data-id="element-118"></span>
          </a>

          <div className="relative group" data-id="element-119">
            <button className="flex items-center gap-1 text-sm uppercase tracking-widest font-sans hover:text-taupe-dark transition-colors py-2" data-id="element-120">
              Services{' '}
              <ChevronDown size={14} className="transition-transform duration-300 group-hover:rotate-180" data-id="element-121" />
            </button>
            <div className="absolute top-full left-0 pt-4 opacity-0 translate-y-2 pointer-events-none group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto transition-all duration-300 w-64" data-id="element-122">
              <div className="bg-white shadow-xl border border-taupe/20 py-4 flex flex-col" data-id="element-123">
                {services.map((service, idx) => <a key={idx} href="#what-we-do" className="px-6 py-2 text-sm font-sans hover:bg-cream hover:text-taupe-dark transition-colors" data-id="element-124">
                    {service}
                  </a>)}
              </div>
            </div>
          </div>

          {navLinks.slice(1).map((link, idx) => <a key={idx} href={link.href} className="text-sm uppercase tracking-widest font-sans hover:text-taupe-dark transition-colors relative group" data-id="element-125">
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-taupe-dark transition-all duration-300 group-hover:w-full" data-id="element-126"></span>
            </a>)}
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-black p-2" onClick={() => setIsMobileMenuOpen(true)} data-id="element-127">
          <Menu size={24} data-id="element-128" />
        </button>
      </div>

      {/* Mobile Menu Drawer */}
      <AnimatePresence data-id="element-129">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/50 z-50 lg:hidden flex justify-end" onClick={() => setIsMobileMenuOpen(false)} data-id="element-130">
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'tween',
          duration: 0.3
        }} className="w-[80%] max-w-sm bg-cream h-full shadow-2xl flex flex-col" onClick={e => e.stopPropagation()} data-id="element-131">
              <div className="p-6 flex justify-between items-center border-b border-taupe/20" data-id="element-132">
                <span className="font-serif text-xl" data-id="element-133">Menu</span>
                <button onClick={() => setIsMobileMenuOpen(false)} className="p-2" data-id="element-134">
                  <X size={24} data-id="element-135" />
                </button>
              </div>
              <div className="flex-1 overflow-y-auto py-6 px-6 flex flex-col gap-6" data-id="element-136">
                <a href="#" className="text-sm uppercase tracking-widest font-sans" onClick={() => setIsMobileMenuOpen(false)} data-id="element-137">
                  Home
                </a>

                <div className="flex flex-col gap-4" data-id="element-138">
                  <span className="text-sm uppercase tracking-widest font-sans text-taupe-dark" data-id="element-139">
                    Services
                  </span>
                  <div className="flex flex-col gap-3 pl-4 border-l border-taupe/30" data-id="element-140">
                    {services.map((service, idx) => <a key={idx} href="#what-we-do" className="text-sm font-sans" onClick={() => setIsMobileMenuOpen(false)} data-id="element-141">
                        {service}
                      </a>)}
                  </div>
                </div>

                {navLinks.slice(1).map((link, idx) => <a key={idx} href={link.href} className="text-sm uppercase tracking-widest font-sans" onClick={() => setIsMobileMenuOpen(false)} data-id="element-142">
                    {link.name}
                  </a>)}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}